import { useBreakpointValue } from '@chakra-ui/react';

import asBentoModule from 'common/bento/hoc/asBentoModule';
import withStateMachine from 'common/bento/hoc/withStateMachine/withStateMachine';
import assertNever from 'common/bento/lib/assertNever';
import stringifyState from 'common/bento/lib/stringifyState';

import OBLoaderPage from '../../components/OBLoaderPage/OBLoaderPage';
import machineConfig, { model, State } from './machine';
import ResearchAccepted from './pages/ResearchAccepted';
import ResearchExperimentPage from './pages/ResearchExperiment';

const ResearchExperimentComponent = withStateMachine<typeof model>(
  ({ machine }) => {
    const [state, send] = machine;

    const stringifiedState = stringifyState<State>(state);

    switch (stringifiedState) {
      case State.RESEARCH_EXPERIMENT:
        return (
          <ResearchExperimentPage
            onAccept={() => send(model.events.ACCEPT_RESEARCH_EXPERIMENT())}
            onDecline={() => send(model.events.DECLINE_RESEARCH_EXPERIMENT())}
            onPrev={() => send(model.events.PREV())}
          />
        );

      case State.RESEARCH_ACCEPTED:
        return (
          <ResearchAccepted
            onCancel={() => send(model.events.CANCEL_RESEARCH_EXPERIMENT())}
            onPrev={() => send(model.events.PREV())}
          />
        );

      case State.RESEARCH_EXPERIMENT_EVALUATION:
      case State.ABORT_TO_RESET_PROMPT:
      case State.INIT:
      case State.DONE:
      case State.ABORT:
        return <OBLoaderPage onPrev={() => null} />;

      default:
        return assertNever(stringifiedState);
    }
  },
  {
    devTools: true,
    machineConfig,
  },
);

interface ResearchExperimentProps {
  uid: string;
}

const ResearchExperiment = asBentoModule<ResearchExperimentProps>(
  ({ onDone, uid }) => {
    const isMobile = Boolean(
      useBreakpointValue(
        {
          base: true,
          lg: false,
        },
        // We need to pass an empty default breakpoint to get the right value in the first render (the initial value is 'base' by default)
        '',
      ),
    );

    return (
      <ResearchExperimentComponent
        moduleData={{ isMobile, uid }}
        onDone={onDone}
      />
    );
  },
);

export default ResearchExperiment;
